<template>
    <div :style="mainContentViewHeight" class="department"
         v-loading="loading"
         element-loading-text="拼命加载中">

        <div class="department-box" :style="mainContentViewHeight" v-if="hasRoleList">
            <div class="aside" :style="leftContentViewHeight">
               <div  class="title">
                   <h3>
                       角色列表
                   </h3>
               </div>
                <el-menu>
                    <el-menu-item-group v-for="(roleList,key) in roleGroupList" :key="key">
                        <span slot="title">{{key}}</span>
                        <el-menu-item v-for="(item,index) in roleList"
                                      class="cate-item"
                                      :key="item.id"
                                      @click="handleCateClick(item,key)"
                                      :index="getIndex(item,index)">{{item.name}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-menu>
            </div>
            <el-card class="box-card main" style="padding-top: 10px;" :style="leftContentViewHeight">
                <h3 class="form-header" id="basicInfo">
                   <span> 角色与用户管理</span>
                    <el-button v-if="selectItem.id && !selectItem.isSystem" type="text" style="margin-right: 10px"  class="pull-right text-button"
                            @click="deleteHandle(selectItem.id)">删除
                    </el-button>
                    <el-button  type="text"   v-if="selectItem.id"  class="pull-right text-button" style="margin-right: 10px"
                                @click="addOrUpdateHandle(selectItem.id)">编辑
                    </el-button>
                    <el-button   type="text"   style="margin-right: 10px" class="pull-right text-button"
                                 @click="addOrUpdateHandle('')">新增角色
                    </el-button>
                </h3>
                <el-divider></el-divider>
                <el-main style="padding-top: 0; "
                         v-if="selectItem.id ">
                    <el-form ref="dataForm"
                             label-width="120px" class="two-item-form detail-form">
                       <!-- <el-form-item label="应用名称:" class="single-item input-media">
                            <span>{{selectAppName}}  </span>
                        </el-form-item>-->
                        <el-form-item label="角色名称:" class="single-item input-media">
                            <span>{{selectItem.name}}  </span>
                        </el-form-item>
                        <el-form-item label="角色代码:" v-if="false" class="single-item input-media">
                            <span>{{selectItem.roleCode}} </span>
                        </el-form-item>
                        <el-form-item label="内置角色:" v-if="selectItem.internalRoleId" class="single-item input-media">
                            <span>{{selectItem.attributes!==undefined? selectItem.attributes.internalRoleId:selectItem.internalRoleId}} </span>
                        </el-form-item>
                       <!-- <el-form-item label="排序:" class="single-item input-media">
                            <span>{{selectItem.sort}}</span>
                        </el-form-item>-->
                        <el-form-item label="状态:" class="single-item input-media">
                            <span>{{selectItem.enabled?'启用':'禁用'}}</span>
                        </el-form-item>
                        <el-form-item label="备注:" class="single-item input-media">
                            <span>{{selectItem.remark}} </span>
                        </el-form-item>
                        <h3 class="form-header header-marign" id="adminInfo"  v-if="!selectItem.internalRoleId" >
                            授权用户
                            <el-button type="text" @click="addEmployeeHandler" class="pull-right text-button">选择用户
                            </el-button>
                        </h3>
                        <el-divider></el-divider>
                    </el-form>
                    <el-table :data="dataList"
                              border  v-if="!selectItem.internalRoleId" 
                              v-loading="dataListLoading"
                              style="width: 100%;">
                        <el-table-column
                                fixed
                                type="index"
                                header-align="left"
                                align="left"
                                label="序号"
                                :index="getRowsIndex"
                                width="60"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="userName"
                                width="100"
                                header-align="left"
                                align="left"
                                label="用户名">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="realName"
                                header-align="left"
                                align="left"
                                label="姓名">
                        </el-table-column>
                        <el-table-column
                                fixed
                                width="160"
                                prop="mobile"
                                header-align="left"
                                align="left"
                                label="联系手机">
                        </el-table-column>
                        <el-table-column
                                width="180"
                                prop="email"
                                header-align="left"
                                align="left"
                                label="email">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                header-align="center"
                                align="center"
                                width="150"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="deleteUserRole(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            @size-change="sizeChangeHandle"
                            @current-change="currentChangeHandle"
                            :current-page="pageIndex"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pageSize"
                            :total="totalPage"
                            layout="total, sizes, prev, pager, next, jumper">
                    </el-pagination>
                </el-main>
                <el-main style="padding-top: 0" v-else>
                    <span style="line-height: 40px;padding-left: 0px;font-size: 18px;" v-if="roleGroupList.length>0">请选择角色</span>
                    <span style="line-height: 40px;padding-left: 0px;font-size: 18px;" v-else>暂无数据</span>
                </el-main>
            </el-card>
        </div>
        <div class="department-box" :style="mainContentViewHeight" v-else>
            <el-card class="box-card main " :style="leftContentViewHeight">
                <div class="site-content">
                    <p class="not-found-desc">暂时不存在<em>角色</em>，请先
                        <el-button class="text-button text-button-larger" type="text" @click="addOrUpdateHandle('')">添加角色
                        </el-button>
                    </p>
                </div>
            </el-card>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"
                       @refreshDataList="reloadData"></add-or-update>
        <select-role-user v-if="selectRoleVisible" ref="selectRole"
                          @refreshDataList="getDataList"></select-role-user>
    </div>
</template>

<script>
    import AddOrUpdate from "./role-edit";
    import SelectRoleUser from "./role-select-user";

    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                loading:true,
                roleGroupList: [],
                dataList: [],
                searchKey: '',
                orgId: '',
                selectAppName: '',
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                selectItem: {id: ''},
                selectRoleVisible: false,
                addOrUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate, SelectRoleUser
        },
        computed: {
            isSupperAdmin: {
                get() {
                    return this.$store.state.user.supperAdmin === true || this.$store.state.user.supperAdmin === 'true'
                }
            },
            leftContentViewHeight: {
                get() {
                    return {height: this.mainContentViewHeight.minHeight}
                }
            },
            selectItemId: {
                get() {
                    return this.selectItem.id
                }
            },
            hasRoleList: {
                get() {
                    if(!this.roleGroupList){
                        return false
                    }
                    for ( var name in this.roleGroupList ) {
                        return true;
                    }
                    return false
                }
            }
        },
        methods: {
            reloadData() {
                this.getRoleList()
                this.getDataList()
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            getOrgId() {
                return this.orgId
            },
            getIndex(item,index) {
                return "4-" +item.id+'-'+ index
            },
            handleCateClick(item,selectAppName) {
                this.selectItem = item
                this.selectAppName = selectAppName
                this.getDataList()
            },
            getDataList() {
                let url = 'auth/employee/searchlist'
                let params = {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'searchKey': '',
                    'filter': {roleId: this.selectItem.id, actionType: 1}
                }
                this.$http.post(url, params).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows
                        this.totalPage = data.totalItemCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            getRoleList() {
                this.$http.get('auth/role/getGroupByOrgId?orgId=' + this.getOrgId(), {}).then(res => {
                    this.roleGroupList = res.data
                    this.loading=false
                }).catch(err => {
                    this.loading=false
                })
            }, // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id, this.getOrgId())
                })
            },
            // 新增 / 修改
            addEmployeeHandler() {
                this.selectRoleVisible = true
                this.$nextTick(() => {
                    this.$refs.selectRole.init(this.selectItem.id, this.getOrgId())
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let delReq={
                        id:id
                    }
                    this.$http.post('/auth/role/deleteRole',delReq).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getRoleList()
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            },
            deleteUserRole(userId) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: '/auth/role/deleteauthuser?ids=' + userId + '&roleId=' + this.selectItem.id + '&appId=' + this.getOrgId(),
                        method: 'post',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        },
        mounted() {
            let orgId=this.$route.query.orgId
            if(orgId==undefined){
                orgId=this.$route.params.orgId
            }
            this.orgId=orgId 
            if(!this.orgId){
                this.$showErrorPage('组织机构信息无效')
                return
            }
            this.getRoleList()
        }
    }
</script>

<style scoped lang="scss">
    .department {
        position: relative;

        .department-box {
            display: flex;
        }
    }

    .department-box {
        .aside, .main {
            background-color: #fff;
        }

    }

    .text-button{
        margin-right: 10px;
    }

    .el-header {
    }

    .el-aside {
    }
</style>
